/**
 * Deux colonnes : l'une sous l'autre sur un téléphone, côte à côte et de même largeur à partir de
 * `md` (800) — la mise en page de l'Abonnement (`<SubscriptionPortalTemplate>`) et du parrainage
 * (`<ReferralDashboardPage>`).
 *
 * Une feuille partagée plutôt qu'un composant : la page et son squelette posent LA MÊME, pour que le
 * contenu tombe là où le squelette l'annonçait, et qu'une retouche de la rupture se voie aux deux.
 */
import { StyleSheet } from "react-native-unistyles"

export const columnStyles = StyleSheet.create((theme) => ({
    columns: {
        flexDirection: { xs: "column", md: "row" },
        alignItems: { xs: "stretch", md: "flex-start" },
        gap: theme.spacing["4"],
    },
    column: {
        alignSelf: "stretch",
        flexGrow: { xs: 0, md: 1 },
        flexBasis: { xs: "auto", md: 0 },
    },
}))
